module.exports = __webpack_public_path__ + "img/layers-2.24cf1251.svg";